module.exports = __webpack_public_path__ + "img/product30-chaxun.612604ff.svg";